import { ReactNode } from 'react';
import {  Route } from 'react-router-dom';
import PageWrapper from '../components/layout/PageWrapper';
import appRoutes from './appRoutes';
import { RouteType } from './config';
import InfluencerProtectedRoute from './influencerProtectedRoute';

const generateRoute = (routes: RouteType[]) => {
  return routes.map((route, index) =>
    route.index ? (
      <Route
        index
        path={route.path}
        // element={renderRoute(route.path,<PageWrapper state={route.state}>{route.element}</PageWrapper>)}
        element={
          <PageWrapper>
            <InfluencerProtectedRoute>
              {route.element}
            </InfluencerProtectedRoute>
          </PageWrapper>
        }
        key={index}
      />
    ) : (
      <Route
        path={route.path}
        // element={renderRoute(route.path,<PageWrapper state={route.child ? undefined : route.state}>{route.element}</PageWrapper>)}
        element={
          <PageWrapper>
            <InfluencerProtectedRoute>
              {route.element}
            </InfluencerProtectedRoute>
          </PageWrapper>
        }
        key={index}
      >
        {route.child && generateRoute(route.child)}
      </Route>
    )
  );
};

export const routes: ReactNode = generateRoute(appRoutes);
